export default __webpack_public_path__ + "static/media/favImg.906d599c.svg";